export default function ({ store, redirect, localePath }) {
  if (!store.state.applicationForms.user.token) {
    return redirect(
      localePath({
        name: 'login',
      })
    )
  }
}
